<template>
    <div>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item>
                    <i class='el-icon-lx-cascades'></i> 设备组管理
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class='container'>

           <div class='handle-box'>
            <el-select v-model='enterpriseSearchId' placeholder='企业' style='width: 140px;margin-right: 20px'>
                <el-option
                    v-for='item in enterpiseOptionsSearch'
                    :key='item.value'
                    :label='item.label'
                    :value='item.value'>
                </el-option>
            </el-select>


                <el-button type='primary' icon='el-icon-search' @click='handleSearch'>查询</el-button>
                <el-button
                    type='primary'
                    icon='el-icon-plus'
                    class='handle-del mr10'
                    @click='addUser'
                >添加设备组
                </el-button>
            </div>
            <el-table
                :data='tableData'
                border
                class='table'
                ref='multipleTable'
                header-cell-class-name='table-header'
            >
                <el-table-column type='selection' width='55' align='center' v-if='false'></el-table-column>
                <el-table-column label='序号' align='center' :index='indexMethod' width='40' type='index'>

                </el-table-column>
                <el-table-column label='单位' align='center' width='80px'>
                    <template slot-scope='scope'>{{ scope.row.enterpriseName }}</template>
                </el-table-column>
                <el-table-column label='组名' align='center' width='80px'>
                    <template slot-scope='scope'>{{ scope.row.name }}</template>
                </el-table-column>
<!--                <el-table-column label='联系人' align='center' width='70px'>-->
<!--                    <template slot-scope='scope'>{{ scope.row.concatName }}</template>-->
<!--                </el-table-column>-->
<!--                <el-table-column label='联系电话' align='center' width='110px'>-->
<!--                    <template slot-scope='scope'>{{ scope.row.phone }}</template>-->
<!--                </el-table-column>-->

                <el-table-column label='剩余金额' align='center' width='80px'>
                    <template slot-scope='scope'>{{ scope.row.amountIsShow === 1 ? '显示' : '不显示' }}</template>
                </el-table-column>
                <el-table-column label='消费金额' align='center' width='80px'>
                    <template slot-scope='scope'>{{ scope.row.camountIsShow === 1 ? '显示' : '不显示' }}</template>
                </el-table-column>
                <el-table-column label='打折' align='center' width='80px'>
                    <template slot-scope='scope'>{{ scope.row.isDiscount === 1 ? '打折' : '不打折' }}</template>
                </el-table-column>
                <el-table-column label='消费折扣' align='center' width='80px'>
                    <template slot-scope='scope'>{{ scope.row.cdiscount + '%' }}</template>
                </el-table-column>
                <el-table-column label='支持餐段' align='center'>
                    <template slot-scope='scope'>{{ scope.row.mealNames }}</template>
                </el-table-column>
                <el-table-column label='支持卡类' align='center'>
                    <template slot-scope='scope'>{{ scope.row.cardNames }}</template>
                </el-table-column>
                <el-table-column label='状态' align='center'>
                    <template slot-scope='scope'>
                        <el-tag
                            :type="scope.row.status===1?'':'danger'"
                        >{{ scope.row.status === 1 ? '正常' : '禁用' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label='备注' align='center'>
                    <template slot-scope='scope'>{{ scope.row.remark }}</template>
                </el-table-column>
                <el-table-column prop='createTime' label='创建时间' align='center' width='140px'>
                    <template slot-scope='scope'>{{ scope.row.createTime }}</template>

                </el-table-column>
                <el-table-column label='操作' width='180' align='center'>
                    <template slot-scope='scope'>
                        <el-button
                            type='text'
                            icon='el-icon-edit'
                            @click='handleEdit(scope.$index, scope.row)'
                        >编辑
                        </el-button>
                        <el-button
                            type='text'
                            icon='el-icon-edit'
                            @click='getDeviceGroupMealHttp(scope.$index, scope.row)'
                        >编辑餐段
                        </el-button>
                        <el-button
                            type='text'
                            icon='el-icon-delete'
                            class='red'
                            @click='handleDelete(scope.$index, scope.row)'
                        >删除
                        </el-button>
                        <el-button
                            type='text'
                            class='blue'
                            @click='handleForbidden(scope.$index, scope.row)'
                        >{{ scope.row.status === 1 ? '禁用' : '解除禁用' }}
                        </el-button>
                    </template>
                </el-table-column>

            </el-table>
            <div class='pagination'>
                <el-pagination
                    background
                    layout='total, prev, pager, next'
                    :current-page='query.pageIndex'
                    :page-size='query.pageSize'
                    :total='pageTotal'
                    @current-change='handlePageChange'
                ></el-pagination>
            </div>
        </div>
        <el-dialog title='编辑餐段' :visible.sync='editMealVisible' width='40%'>

            <el-table
                :data='editMealTable'
                border
                class='table'
                ref='multipleTable'
                header-cell-class-name='table-header'
            >
                <el-table-column type='selection' width='55' align='center' v-if='false'></el-table-column>
                <el-table-column label='序号' align='center' :index='indexMethod' width='80' type='index'>
                </el-table-column>

                <el-table-column label='餐段名称' align='center'>
                    <template slot-scope='scope'>{{ scope.row.name }}</template>
                </el-table-column>
                <el-table-column label='开始时间' align='center'>
                    <template slot-scope='scope'>{{ scope.row.startTime }}</template>
                </el-table-column>
                <el-table-column label='结束时间' align='center'>
                    <template slot-scope='scope'>{{ scope.row.endTime }}</template>
                </el-table-column>
                <el-table-column label='状态' align='center'>
                    <template slot-scope='scope'>
                        <el-tag
                            :type="scope.row.status==1?'':'danger'"
                        >{{ scope.row.status == 1 ? '正常' : '禁用' }}
                        </el-tag>

                    </template>
                </el-table-column>
                <el-table-column label='操作' width='180' align='center'>
                    <template slot-scope='scope'>
                        <el-button
                            type='text'
                            @click='handleMealEdit(scope.$index, scope.row)'
                        >编辑
                        </el-button>
                        <el-button
                            type='text'
                            class='blue'
                            @click='handleStatusForbidden(scope.$index, scope.row)'
                        >{{ scope.row.status === 1 ? '禁用' : '解除禁用' }}
                        </el-button>
                    </template>
                </el-table-column>

            </el-table>

            <span slot='footer' class='dialog-footer'>
<!--                <el-button @click='editMealVisible = false'>取 消</el-button>-->
                <el-button type='primary' @click='editMealVisible = false'>确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog title='编辑设备组' :visible.sync='editVisible' width='40%'>


            <el-form ref='form' :model='form' label-width='90px'>
                <el-form-item label='设备组名'>
                    <el-input v-model='form.name'></el-input>
                </el-form-item>
                <el-form-item label='所属企业' >
                    <el-select v-model='enterpriseId' placeholder='请选择'  disabled >
                        <el-option
                            v-for='item in enterpiseOptions'
                            :key='item.value'
                            :label='item.label'
                            :value='item.value'>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label='支持卡类'>
                    <el-select v-model='form.cardIds' multiple placeholder='请选择' >
                        <el-option
                            v-for='item in cardOptions'
                            :key='item.value'

                            :label='item.label'
                            :value='item.value'>
                        </el-option>
                    </el-select>
                </el-form-item>

<!--                <el-form-item label='联系人'>-->
<!--                    <el-input v-model='form.concatName'></el-input>-->
<!--                </el-form-item>-->
<!--                <el-form-item label='联系电话'>-->
<!--                    <el-input v-model='form.phone'></el-input>-->
<!--                </el-form-item>-->
                <el-form-item label='是否折扣'>
                    <template>
                        <el-radio v-model="isDiscount" label="1">是</el-radio>
                        <el-radio v-model="isDiscount" label="0" disabled>否</el-radio>
                    </template>
                </el-form-item>
                <el-form-item label='消费折扣' type='number' >
                    <el-input v-model='form.cdiscount' :disabled='isDiscount=="0"'></el-input>
                </el-form-item>
                <el-form-item label='剩余金额'>
                    <template>
                        <el-radio v-model="amountIsShow" label="1">显示</el-radio>
                        <el-radio v-model="amountIsShow" label="0" disabled>不显示</el-radio>
                    </template>
                </el-form-item>
                <el-form-item label='消费金额'>
                    <template>
                        <el-radio v-model="camountIsShow" label="1">显示</el-radio>
                        <el-radio v-model="camountIsShow" label="0" disabled>不显示</el-radio>
                    </template>
                </el-form-item>

                <el-form-item label='备注'>
                    <el-input v-model='form.remark'></el-input>
                </el-form-item>
            </el-form>
            <span slot='footer' class='dialog-footer'>
                <el-button @click='editVisible = false'>取 消</el-button>
                <el-button type='primary' @click='editHttp'>确 定</el-button>
            </span>
        </el-dialog>


        <!-- 添加用户 -->
        <el-dialog title='添加设备组' :visible.sync='addVisible' width='40%'>


            <el-form ref='form' :model='form' label-width='90px'>
                <el-form-item label='设备组名'>
                    <el-input v-model='createForm.name'></el-input>
                </el-form-item>
                <el-form-item label='所属企业'>
                    <el-select v-model='enterpriseId' placeholder='请选择'   >
                        <el-option
                            v-for='item in enterpiseOptions'
                            :key='item.value'
                            :label='item.label'
                            :value='item.value'>
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label='支持卡类'>
                    <el-select v-model='createForm.cardIds' multiple placeholder='请选择' >
                        <el-option
                            v-for='item in cardOptions'
                            :key='item.value'

                            :label='item.label'
                            :value='item.value'>
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label='联系人'>
                    <el-input v-model='createForm.concatName'></el-input>
                </el-form-item>
                <el-form-item label='联系电话'>
                    <el-input v-model='createForm.phone'></el-input>
                </el-form-item>
                <el-form-item label='是否折扣'>
                    <template>
                        <el-radio v-model="isDiscount" label="1">是</el-radio>
                        <el-radio v-model="isDiscount" label="0">否</el-radio>
                    </template>
                </el-form-item>
                <el-form-item label='消费折扣' type='number' >
                    <el-input v-model='createForm.cdiscount' :disabled='isDiscount=="0"'></el-input>
                </el-form-item>
                <el-form-item label='剩余金额'>
                    <template>
                        <el-radio v-model="amountIsShow" label="1">显示</el-radio>
                        <el-radio v-model="amountIsShow" label="0">不显示</el-radio>
                    </template>
                </el-form-item>
                <el-form-item label='消费金额'>
                    <template>
                        <el-radio v-model="camountIsShow" label="1">显示</el-radio>
                        <el-radio v-model="camountIsShow" label="0">不显示</el-radio>
                    </template>
                </el-form-item>

                <el-form-item label='备注'>
                    <el-input v-model='createForm.remark'></el-input>
                </el-form-item>

            </el-form>

            <span slot='footer' class='dialog-footer'>
                        <el-button @click='addVisible = false'>取 消</el-button>
                        <el-button type='primary' @click='addUserHttp'>确 定</el-button>
                    </span>
        </el-dialog>

        <el-dialog title='编辑餐别' :visible.sync='editMealDetailVisible' width='40%'>


            <el-form ref='form' :model='form' label-width='120px'>
                <el-form-item label='餐别名称'>
                    <el-input v-model='form.name' maxlength='11'></el-input>
                </el-form-item>
                <el-form-item label='时间范围'>
                    <el-time-picker
                        is-range
                        v-model='timeRange'
                        value-format='HH:mm'

                        range-separator='至'
                        start-placeholder='开始时间'
                        end-placeholder='结束时间'
                        placeholder='选择时间范围'>
                    </el-time-picker>
                </el-form-item>

            </el-form>

            <span slot='footer' class='dialog-footer'>
                <el-button @click='editMealDetailVisible = false'>取 消</el-button>
                <el-button type='primary' @click='editMealDetailHttp'>确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
import { countDown, formatDate, formatDates } from '@/utils/formatDate';

export default {
    name: 'basetable',
    data() {
        return {
            amountIsShow:"1",
            camountIsShow:"1",
            enterpriseId:"",
            isDiscount:"0",
            queryEnterprise: {
                name: '',
                pageIndex: 1,
                pageSize: 999999
            },
            enterpiseOptions: [],
            enterpiseValue: '',
            mealOptions:[],
            cardOptions:[],
            mealValue: '',
            enterpriseSearchId:'',
            query: {
                name: '',
                pageIndex: 1,
                pageSize: 10
            },
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            addVisible: false
            ,
            createForm: {
                mealIds:"",
                cardIds:"",
                remark:"",
            }
            ,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
            options: [],
            value: '',
            editCurrentProgress: '1',
            editCurrentProgressName: '',
            enterpiseOptionsSearch:[],
            editMealVisible:false,
            editMealTable :[],
            editMealDetailVisible:false,
            timeRange:[]


        };
    },
    watch:{
        enterpriseId(newV,oldV){
            this.mealOptions=[];
            this.cardOptions=[]

            this.getMeals();
            this.getCardList();
        }
    },
    created() {
        this.getEnterpise();
        this.getData();
        this.getEnterpiseSearch();


    },


    methods: {
        getDeviceGroupMealHttp(index, row){
            let that = this;
            let paramData = {"deviceGroupId":row.id}
            this.http.getToken('/device/getDeviceGroupMeal', paramData).then(res => {
                    if (res.code == 0) {
                        that.editMealVisible = true
                        that.editMealTable=res.data

                    }
                },
                err => {

                });
        }
        ,
        getEnterpise() {
            let that = this;
            this.http.getToken('enterprise/getList', this.queryEnterprise).then(res => {
                    if (res.code == 0) {
                        that.enterpiseOptions.push({ 'value': '', 'label': '请选择企业' });
                        res.data.records.forEach(res => {
                            that.enterpiseOptions.push({ 'value': res.id, 'label': res.name });
                        });

                    }
                },
                err => {


                });
        },
        getMeals() {
            let that = this;
            this.http.getToken('meal/getList', {"pageIndex":1,"pageSize":99999,"enterpriseId":this.enterpriseId}).then(res => {
                    if (res.code == 0) {
                        res.data.records.forEach(res => {
                            that.mealOptions.push({ 'value': res.id, 'label': res.name });
                        });

                    }
                },
                err => {


                });
        },

        getCardList(){

            let that = this;
            this.http.getToken('card/getList', {"pageIndex":1,"pageSize":99999,"enterpriseId":this.enterpriseId}).then(res => {
                    if (res.code == 0) {
                        res.data.records.forEach(res => {
                            that.cardOptions.push({ 'value': res.id, 'label': res.typeName });
                        });

                    }
                },
                err => {


                });
        }
        ,
        //禁用
        handleForbidden(index, row) {
            // 二次确认删除
            console.log(index);
            console.log(row.uid);
            let that = this;
            let params = {};
            let msg = '';
            if (row.status == 1) {
                msg = '确定要' + '禁用' + '吗？';
                params = { 'id': row.id, 'status': 0 };
            } else {
                msg = '确定要' + '解除禁用' + '吗？';
                params = { 'id': row.id, 'status': 1 };
            }

            this.$confirm(msg, '提示', {
                type: 'warning'
            })
                .then(() => {
                    that.http.postToken('device/updateStatusDeviceGroupById', params).then(res => {
                        if (res.code == 0) {
                            that.getData();
                            this.$message.success('操作成功');
                        }
                    });

                })
                .catch(() => {
                });
        },
        //禁用
        handleStatusForbidden(index, row) {
            // 二次确认删除
            let that = this;
            let params = {};
            let msg = '';
            if (row.status == 1) {
                msg = '确定要' + '禁用' + '吗？';
                params = { 'id': row.id, 'status': 0 };
            } else {
                msg = '确定要' + '解除禁用' + '吗？';
                params = { 'id': row.id, 'status': 1 };
            }

            this.$confirm(msg, '提示', {
                type: 'warning'
            })
                .then(() => {
                    that.http.postToken('device/updateStatusById', params).then(res => {
                        if (res.code == 0) {
                            if (row.status ==1){
                                row.status=0
                            }else {
                                row.status=1
                            }

                            this.$message.success('操作成功');
                        }
                    });

                })
                .catch(() => {
                });
        },
        indexMethod(index) {
            return index + 1;
        },
        // 触发搜索按钮
        handleSearch() {
            this.query.pageIndex = 1;
            this.getData();

        }
        ,
        getEnterpiseSearch() {
            let that = this;
            this.http.getToken('/enterprise/getList', this.queryEnterprise).then(res => {
                    if (res.code == 0) {
                        that.enterpiseOptionsSearch.push({ 'value': '', 'label': '请选择企业' });
                        res.data.records.forEach(res => {
                            that.enterpiseOptionsSearch.push({ 'value': res.id, 'label': res.name });
                        });

                    }
                },
                err => {

                });
        },
        getData() {
            let that = this;
            this.query.enterpriseId=this.enterpriseSearchId
            this.http.getToken('device/getDeviceGroupList', this.query).then(res => {
                    if (res.code == 0) {
                        res.data.records.forEach(res => {
                            let cardNames = '';
                            let mealNames = '';
                            res.wxtYktCardPoList.forEach(r => {
                                cardNames = cardNames + r.typeName + ',';

                            });
                            if (cardNames.length > 0) {
                                cardNames = cardNames.substring(0, cardNames.length - 1);
                            }
                            res.cardNames = cardNames;
                            res.wxtYktMealSetPos.forEach(r => {
                                mealNames = mealNames + r.name + ',';

                            });
                            if (mealNames.length > 0) {
                                mealNames = mealNames.substring(0, mealNames.length - 1);
                            }
                            res.mealNames = mealNames;

                        });
                        that.tableData = res.data.records;
                        that.pageTotal = parseInt(res.data.total);
                        this.$message.success('获取数据成功');

                    }
                },
                err => {

                });
        },
        delUserHttp(id) {
            let that = this;
            this.http.postToken('device/delDeviceGroupById', { 'id': id }).then(res => {
                    if (res.code == 0) {
                        that.getData();
                        that.$message.success('删除成功');
                    }
                },
                err => {

                });
        }
        ,
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            let that = this;
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    that.delUserHttp(row.id);

                })
                .catch(() => {
                });
        },

        addUser() {


            this.mealOptions=[];
            this.createForm.mealIds='';
            this.cardOptions=[]
            this.createForm.cardIds='';
            this.createForm = {};
            this.enterpriseId=''
            this.cardOptions=[]
            this.addVisible = true;
        },

        addUserHttp() {
            if (this.createForm.cardIds.length==0){
                this.$message.error('未选择卡类');
                return
            }
            // if (this.createForm.mealIds.length==0){
            //     this.$message.error('未选择餐别');
            //     return
            // }
            let that = this;
            this.createForm.enterpriseId=this.enterpriseId;
            this.createForm.camountIsShow=this.camountIsShow;
            this.createForm.amountIsShow=this.amountIsShow;
            this.createForm.isDiscount = this.isDiscount

            this.http.postToken('device/addDeviceGroup', this.createForm).then(res => {
                if (res.code === 0) {
                    this.mealOptions=[];
                    this.createForm.mealIds='';
                    this.cardOptions=[]
                    this.createForm.cardIds='';
                    this.createForm = {};
                    this.enterpriseId=''
                    that.getData();
                    that.addVisible = false;
                    this.$message.success('添加成功');
                }

            });
        }
        ,
        editHttp() {
            let that = this;
            this.form.enterpriseId=this.enterpriseId;
            this.form.camountIsShow=this.camountIsShow;
            this.form.amountIsShow=this.amountIsShow;
            this.form.isDiscount = this.isDiscount
            this.options.forEach(function(element) {
                if (element.name === that.editCurrentProgressName) {
                    that.editCurrentProgress = element.type;
                }

            });
            this.http.postToken('device/updateDeviceGroupById', this.form).then(res => {
                if (res.code == 0) {
                    that.getData();
                    that.editVisible = false;
                    that.$message.success('编辑成功');
                }

            });
        }
        ,
        editMealDetailHttp(){
            let that = this;
            let startTime = this.timeRange[0];
            let endTime = this.timeRange[1];
            let params = {};
            params['startTime'] = startTime;
            params['name'] = this.form.name;
            params['id'] = this.form.id;
            params['endTime'] = endTime;
            params['deviceGroupId']= this.form.deviceGroupId
            this.http.postToken('device/updateDeviceGroupMealById', params).then(res => {
                if (res.code == 0) {
                    that.editMealDetailVisible = false
                    that.editMealVisible = false
                    that.$message.success('编辑成功');
                    this.getData()
                }

            });
        },
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;

            this.form = JSON.parse(JSON.stringify(row));
            this.camountIsShow = this.form.camountIsShow+"";
            this.cdiscount = this.form.cdiscount+"";
            this.isDiscount = this.form.isDiscount+"";
            this.amountIsShow = this.form.amountIsShow+"";
            this.enterpriseId=this.form.enterpriseId
            this.editVisible = true;
        },
        // 编辑操作
        handleMealEdit(index, row) {
            this.idx = index;
            this.timeRange =[]

            this.timeRange[0] = row.startTime;
            this.timeRange[1] = row.endTime;
            this.form = JSON.parse(JSON.stringify(row));

            this.editMealDetailVisible = true;
        },

        // 保存编辑
        saveEdit() {
            this.editVisible = false;
            this.$message.success(`修改第 ${this.idx + 1} 行成功`);
            this.$set(this.tableData, this.idx, this.form);
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>

.avatar-uploader .el-upload {
    border-radius: 6px;
    width: 80px;
    height: 80px;
    text-align: center;

}

.avatar-uploader {
    border-color: #409EFF;
    text-align: center;
    margin-bottom: 40px;
    text-align: center;

}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    text-align: center;
}

.avatar {
    width: 80px;
    height: 80px;
    display: block;
    margin: auto auto;
    text-align: center;
}

.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
